import { useIntl } from 'react-intl';

import { Button, FocusRingVariants } from '@calm-web/design-system';

import Carousel from '@/components/schools/Carousel';
import FrayedDivider from '@/components/schools/FrayedDivider';
import { SchoolSectionProps } from '@/components/schools/SchoolsLayout/types';
import GridWrapper from '@/components/ui/GridWrapper';

import { slides } from './data';
import messages from './messages';
import { Heading, Wrapper } from './styles';

const SuccessStories = ({ onCtaClick }: SchoolSectionProps) => {
	const { formatMessage } = useIntl();
	return (
		<Wrapper>
			<FrayedDivider />
			<Heading>{formatMessage(messages.heading)}</Heading>
			<GridWrapper>
				<Carousel slides={slides} />
			</GridWrapper>
			<Button
				focusRingVariant={FocusRingVariants.Dark}
				backgroundColor="schoolBlue"
				onPress={() => onCtaClick(messages.heading.defaultMessage)}
			>
				{formatMessage(messages.button)}
			</Button>
		</Wrapper>
	);
};

export default SuccessStories;
